module.exports = __webpack_public_path__ + "img/qrcode101plus.2ce2cc71.png";